import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { SuccessComponent } from "../success.interface";
import { Fiat } from "@models";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { config } from "@config";
import { FiatTransaction } from "@models/transaction";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Component({
	selector: "fiat-withdrawal-fraud",
	templateUrl: "./fiat-withdrawal-fraud.component.html",
	styleUrls: ["./../success-screen.component.scss"],
	standalone: false
})
export class FiatWithdrawalFraudComponent extends SuccessComponent {
	@Input()
	public fiatTransaction: FiatTransaction = null;

	public constructor(
		protected router: Router,
		protected fiatService: FiatService,
		protected accountService: AccountService,
		protected tradableListService: TradableListService,
		protected segmentService: SegmentService,
		protected rudderstackService: RudderstackService
	) {
		super(fiatService, tradableListService, accountService, router, segmentService, rudderstackService);
	}

	public get fiat(): Fiat {
		if (!this.fiatTransaction) {
			return new Fiat();
		}
		return this.fiatService.getItemById(this.fiatTransaction.getFiatId());
	}

	public getHelpdeskLink(): string {
		return this.translationService.getHdLink() + config.externalPaths["withdrawal"]["hdLink"];
	}
}
